import { Module } from "../../models/Module";
import DocumentList from "../genericcrud/DocumentList";
const ModuleMaster = () => {
  return (
    <>{<DocumentList documentMeta={Module} isModel={true}/>}</>
  );
};

export default ModuleMaster;
